import React from 'react';
import PropTypes from 'prop-types';

import Box from 'components/atoms/Box/Box';
import Title from 'components/atoms/Title/Title';
import GridContainer from 'components/atoms/GridContainer/GridContainer';
import GridItem from 'components/atoms/GridItem/GridItem';
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import Divider from 'components/atoms/Divider/Divider';
import { Trans } from 'react-i18next';
// import Illustration from 'components/molecules/Illustration/Illustration';
// import { MathematicalAbilityIcon } from 'assets/iconsList';
import Link from 'components/atoms/Link/Link';

import { APP_SECONDARY, GENETIC_VARIATION_LINK_COLOR } from 'colours';
import Typography from 'components/atoms/Typography/Typography';
import CircleGroup from 'components/molecules/Circle/CircleGroup';

export default function TraitDetails(props) {
  const { title, text, variations, references, item } = props;

  return (
    <Box mx={'60px'} minHeight={'85vh'}>
      <GridContainer direction="column">
        <GridItem>
          <Box pt={4} pb={4}>
            <CircleGroup item={item} />
          </Box>
        </GridItem>
        <GridItem>
          <Title
            variant="h2"
            align="left"
            style={{ textTransform: 'uppercase' }}
          >
            <Trans
              i18nKey="dna24.traitDetails.whatIs"
              values={{
                trait: title,
              }}
            />
          </Title>
        </GridItem>
        <Divider
          orientation="horizontal"
          marginTop="16px"
          marginBottom="16px"
          height="1px"
        />
        <GridItem>
          <Box pb={4}>
            <Paragraph
              style={{
                textAlign: 'justify',
              }}
            >
              {text}
            </Paragraph>
          </Box>
        </GridItem>
        <GridItem>
          <GridContainer direction="row" spacing={4}>
            <GridItem xs={12} md={6}>
              <Title
                variant="h2"
                align="left"
                textColor={APP_SECONDARY}
                style={{ textTransform: 'uppercase' }}
              >
                <Trans i18nKey="dna24.traitDetails.myGeneticVariations" />
              </Title>
              <Divider
                orientation="horizontal"
                marginTop="16px"
                marginBottom="16px"
                height="1px"
              />
              <Paragraph textSize="12px">
                <Trans
                  i18nKey="dna24.traitDetails.myGeneticVariationsExplanation"
                  values={{
                    trait: title.toLowerCase(),
                  }}
                />
              </Paragraph>
              <Box mt={1}>
                <Title variant="h2" textColor={APP_SECONDARY}>
                  <Trans i18nKey="dna24.traitDetails.geneticVariations" />
                </Title>
              </Box>
              {variations &&
                variations.map((v) => {
                  return (
                    <Box display="flex">
                      <Link
                        color={GENETIC_VARIATION_LINK_COLOR}
                        href={`http://useast.ensembl.org/Homo_sapiens/Variation/Explore?v=${v}`}
                        target="_blank"
                      >
                        <Typography
                          textSize="12px"
                          textColor={GENETIC_VARIATION_LINK_COLOR}
                        >
                          > {v}
                        </Typography>
                      </Link>
                    </Box>
                  );
                })}
            </GridItem>
            <GridItem xs={12} sm={6}>
              <Title
                variant="h2"
                align="left"
                textColor={APP_SECONDARY}
                style={{ textTransform: 'uppercase' }}
              >
                <Trans i18nKey="dna24.traitDetails.myReferences" />
              </Title>
              <Divider
                orientation="horizontal"
                marginTop="16px"
                marginBottom="16px"
                height="1px"
              />
              <Paragraph textSize="12px">
                <Trans
                  i18nKey="dna24.traitDetails.readMore"
                  values={{
                    trait: title.toLowerCase(),
                  }}
                />
              </Paragraph>
              {references &&
                references.map((r, ix) => {
                  return (
                    <Box display="flex">
                      <Link href={r} target="_blank">
                        <Typography textSize="12px" textColor={APP_SECONDARY}>
                          > <Trans i18nKey="dna24.traitDetails.resource" />{' '}
                          {ix + 1}
                        </Typography>
                      </Link>
                    </Box>
                  );
                })}
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </Box>
  );
}

TraitDetails.defaultProps = {
  title: PropTypes.string,
  firstCircleLabel: PropTypes.string,
  firstCircleValue: PropTypes.number,
  secondCircleLabel: PropTypes.string,
  secondCircleValue: PropTypes.number,
  text: PropTypes.string,
  variations: PropTypes.arrayOf(PropTypes.string),
  references: PropTypes.arrayOf(PropTypes.string),
};
